var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-calendar',{attrs:{"fullscreen":false,"header-render":_vm.headerRender,"value-format":"YYYY-MM-DD"},on:{"select":_vm.handleSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }